<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.DECLINE_PUBLICATION
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-10">
        <b-field
          :label="General.TYPE"
          class="column is-6 mb-0 pb-0"
          customClass="has-text-color-7"
        >
          <b-dropdown
            v-model="reason_option"
            aria-role="menu"
            :disabled="filled"
            :expanded="isMobile"
          >
            <template slot="trigger">
              <b-button
                slot="trigger"
                class="custom-dropdown-button input level"
                iconRight="chevron-down"
                outlined
              >
                <span>{{
                  reason_option[1] ||
                    General.PLACEHOLDER.FEEDBACK_TYPE_PLACEHOLDER
                }}</span>
              </b-button>
            </template>

            <b-dropdown-item
              v-for="option in optionsReason"
              :key="option[0]"
              aria-role="listitem"
              :value="option"
            >
              {{ option[1] }}
            </b-dropdown-item>
          </b-dropdown></b-field
        ><b-field class="column is-12">
          <div class="is-flex is-flex-direction-column">
            <div class="simple-row">
              <span class="has-text-color-7 has-text-weight-semibold">
                {{ General.REASON }}
              </span>
            </div>
            <b-input
              v-model="message"
              maxlength="200"
              :disabled="filled"
              type="textarea"
            ></b-input>
          </div>
        </b-field>
        <div class="list-container spacing-mb-30 is-size-7">
          <section v-if="!filled" class="is-flex is-justify-content-flex-end">
            <div class="buttons">
              <b-button
                :type="isContrast ? 'is-white-dark' : 'is-primary'"
                @click="confirmAction"
              >
                {{ General.DECLINE.toUpperCase() }}
              </b-button>
            </div>
          </section>

          <b-table
            class="custom-table-process-panel custom-3-columns-doe mt-10"
            :data="listDocuments"
            role="table"
          >
            <template>
              <b-table-column v-slot="props" :label="General.NUP">
                {{ applyMaskNUP(props.row.nup) }}
              </b-table-column>
              <b-table-column v-slot="props" :label="General.DOCUMENT">
                {{ props.row.attachment_name }}
              </b-table-column>
              <b-table-column v-slot="props" :label="General.TYPE">
                {{ props.row.document_type }}
              </b-table-column>
            </template>
          </b-table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { NUP, applyMask } from "@/utils/protocols";

import { App, General } from "@/utils/constants";
import ModalWarning from "@/views/App/ModalWarning.vue";

import ListDocumentsDoe from "@/components/ListDocumentsDoe";

export default {
  name: "ModalDeclinePublication",
  props: {
    listDocuments: {
      type: Array,
      default: () => []
    },
    clearSelection: {
      type: Function,
      default: () => null
    },
    onClose: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      reason_option: [],
      message: ""
    };
  },

  computed: {
    ...mapGetters({
      getDoeSnackList: "getDoeSnackList",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    optionsReason() {
      return Object.entries(this.App.ModalDeclinePublication.REASONS);
    },

    filled() {
      return Boolean(this.listDocuments[0].refuse_option);
    },

    hasRecurrentDoc() {
      return this.listDocuments.some(doc => doc.is_recurrent);
    }
  },

  beforeMount() {
    if (this.listDocuments[0].refuse_option) {
      this.reason_option = this.optionsReason.find(
        item => item[0] === this.listDocuments[0].refuse_option
      );
      this.message = this.listDocuments[0].refuse_justification;
    }
  },

  methods: {
    ...mapActions({
      doeTrigger: "doeTrigger"
    }),

    ...mapMutations({
      setDoeSnackList: "setDoeSnackList",
      clearDoeSnackList: "clearDoeSnackList"
    }),

    async confirmAction() {
      if (this.reason_option.length && this.message.length) {
        if (this.hasRecurrentDoc) {
          this.$buefy.modal.open({
            parent: this,
            component: ModalWarning,
            props: {
              title: General.WARNING,
              message: General.TEXTS.WARNING_DECLINE_DOE,
              confirm: async () => {
                this.declineDoeRequest();
                this.onClose();
                this.close();
              },
              deny: async () => {
                this.onClose();
                this.close();
              },
              buttons: [
                { label: General.YES, isConfirm: true, action: true },
                { label: General.NO, isConfirm: false, action: false }
              ],
              isMessageCentered: true,
              invertOutline: true
            },
            hasModalCard: true,
            trapFocus: true
          });
        } else {
          this.declineDoeRequest();
          this.onClose();
          this.close();
        }
      } else {
        this.snackToast.open({
          message: this.App.ModalDeclinePublication.EMPTY_FIELD,
          type: "is-danger",
          duration: 8000
        });
      }
    },

    declineDoeRequest() {
      const listDocumentsPublication = this.listDocuments.map(document => ({
        attachment_name: document.attachment_name,
        date_programmed: document.programmed_date,
        process_file_id: document.id,
        refuse_option: this.reason_option[0],
        refuse_justification: this.message,
        status: "pending",
        type: "REFUSE"
      }));

      this.setDoeSnackList(listDocumentsPublication);
      this.snackQueue.open({
        id: "doe_Actions",
        parent: this,
        title: this.General.TEXTS.ACTION_QUANTITY.replace(
          "(QUANTITY)",
          this.getDoeSnackList.length
        ),
        closeAction: this.clearDoeSnackList,
        component: ListDocumentsDoe
      });
      this.doeTrigger();
    },

    close() {
      this.clearSelection();
      this.$parent.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
@import "@/assets/scss/common";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 650px;
  max-width: 75vw;
  min-height: 300px;
  max-height: 75vh;
  background-color: $color-1;
  @media screen and (max-width: $tablet) {
    max-width: 100vw;
  }
}
.list-container {
  overflow: auto;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}
</style>
